import React from 'react'
import { useParams } from 'react-router-dom';
import EditEnergyOfficials from '../UpdateEnergyOfficials/EditEnergyOfficials';

function EditEnergyOfficialsPage() {
       const { official_id:id } = useParams();
    return ( 
        <div className= "container-fluid">
                       <EditEnergyOfficials official_id={id} />
        </div>
     );
}

export default EditEnergyOfficialsPage;